export enum WhiteBloodCellDifferentialUnit {
    PERCENT = '%',
    ABSOLUTE_KCELLS = 'Abs (k/mcL)',
    ABSOLUTE_CELLS = 'Abs (cells/uL)'
}
